import React, { useState,useEffect, useContext } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import { apiUrl } from '../pages/UrlParam';
import jwt_decode from 'jwt-decode';
import { CatchWrapperAsync } from '../utils/catchwrapper';
import { Async } from 'react-select';

export const useLoginHook = () =>{
    const [email, setEmail] = useState('');
    const [otp, setOtp] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate(); // Correctly use useNavigate
    const [msg, setMsg] = useState('');
    const [msgOtp, setMsgOtp] = useState('');
    const [roleList, setRoleList] = useState([]);
    const [confirmRolesOpen, setConfirmRolesOpen] = useState(false);
    const [otp_ex, setOtp_Ex] = useState(60)
    const [loginButton,setLoginButton] = useState(false)
    let time;
     useEffect(() => {
        if (localStorage.getItem("token") != null) {
          var decoded = jwt_decode(localStorage.getItem("token"));
          navigate(`${decoded.defaulturl}`);
        }else{
          logout();
        } 
    }, []);

    useEffect(()=>{
      if(confirmRolesOpen == true){
        time = setTimeout(() => {
          if(otp_ex != 0){
              setOtp_Ex((prev) => prev - 1)
          }else{
            CatchWrapperAsync(()=>{
              // UpdateStatusOTP();
            },setMsgOtp)
           
            return () => {clearTimeout(time)}
          }
          
        }, 1000);
      }
    },[confirmRolesOpen])

    const UpdateStatusOTP = async ()  =>{
      CatchWrapperAsync(async () =>{
         await axios.post(`${apiUrl}/api/UpdateExpOTP`,{email : email, status : 1})
      },setMsg)
      
    }

    const sendOTp = async () => {
    
        CatchWrapperAsync(async ()=>{
           const otp = await axios.post(`${apiUrl}/api/UserOTP`, {email : email})
            setOtp_Ex(60)
            setOtp('')
        })
    }

      const Auth = async (e) => {
        e.preventDefault();
        setLoginButton(true)
        CatchWrapperAsync(async () => {
            const response = await axios.post(`${apiUrl}/login`, {
                email: email,
                password: password,
                role : null
              }, {
                headers: {
                 Module : "login"
                },
              });
         
              if (response.status === 200) {
                if(response.data.status == 'ok'){
                 // const otp = await axios.post(`${apiUrl}/api/UserOTP`, {email : email});
                 // if(otp.status == 200){
                       setRoleList(response.data.data)
                        
                      // setOtp_Ex(60)
                      // setOtp('')
                       setConfirmRolesOpen(true)
                       setLoginButton(false)
                      // setMsgOtp('')
                       return () => {
                        clearTimeout(time)
                      }
                 // }
                }
        
                if(response.data.status == 'failed'){
                  setMsg(response.data.message);
                  setLoginButton(false)
                  return;
                }
               

                await logout();
              } else {
                setMsg('Login failed. Please check your credentials.');
              }
        },setMsg)
         
      };
    
      async function logout(){
            CatchWrapperAsync(async ()=>{
                await axios.get(`${apiUrl}/logout`);
            },setMsg)
       }
      
      async function handleSetRoles(role){
            CatchWrapperAsync(async ()=> {
              // if(otp == ''){
              //   setMsgOtp("OTP NUMBER MUST BE FILLED")
              //   return;
              // }
              // let response = await axios.post(`${apiUrl}/api/CheckExpOTP`,{email:email,otp:otp})
              
              // if(response.data.status == 'failed'){
              //      setMsgOtp(response.data.message);
              //      return;
              // }

              let response = await axios.post(`${apiUrl}/login`, {
                    email: email,
                    password: password,
                    role : role,
                  //  otp : otp.trim()
                  });
            
                  if (response.data.status === 'ok') {
                      var decoded = jwt_decode(response.data.message);
                      localStorage.setItem('token', response.data.message); 
                      // CatchWrapperAsync(async () =>{
                      //     await axios.post(`${apiUrl}/api/UpdateExpOTP`,{email : email,status : 1})
                      // },setMsgOtp)
                      navigate(`${decoded.defaulturl}`);
                  }
            },setMsg)
        }

      return {msg,Auth,email,setEmail,password,setPassword,confirmRolesOpen,setConfirmRolesOpen,roleList,handleSetRoles, setOtp, otp,otp_ex,loginButton,msgOtp, sendOTp}
}